var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('svg', {
    attrs: {
      "width": "76",
      "height": "76",
      "viewBox": "0 0 76 76",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "33.2131",
      "y": "11.2319",
      "width": "10",
      "height": "40",
      "fill": "#F22A42"
    }
  }), _c('rect', {
    attrs: {
      "x": "33.2131",
      "y": "54.1943",
      "width": "10",
      "height": "10",
      "fill": "#F22A42"
    }
  }), _c('path', {
    attrs: {
      "d": "M67.1772 15.0606C67.5873 14.7398 67.6607 14.1463 67.3297 13.7443C63.2628 8.80384 58.0017 4.97519 52.0385 2.62553C45.7826 0.160562 38.9815 -0.587027 32.3395 0.460201C25.6976 1.50743 19.4564 4.31139 14.2624 8.58165C9.31145 12.6521 5.48366 17.9138 3.13413 23.866C2.94294 24.3503 3.1953 24.8924 3.68427 25.0714C4.17324 25.2504 4.71359 24.9986 4.90542 24.5145C7.13895 18.8779 10.7687 13.8952 15.46 10.0382C20.3942 5.98148 26.3233 3.31772 32.6332 2.32285C38.943 1.32798 45.4041 2.03819 51.3472 4.37992C56.9977 6.60632 61.9844 10.2305 65.8439 14.9064C66.1754 15.308 66.767 15.3813 67.1772 15.0606Z",
      "fill": "#F22A42"
    }
  }), _c('path', {
    attrs: {
      "d": "M2.87169 27.5624C2.37121 27.4186 1.84776 27.7076 1.71657 28.2115C0.466864 33.0117 0.175594 38.0144 0.862987 42.933C1.59391 48.163 3.41506 53.1812 6.20854 57.6627C9.00201 62.1442 12.7055 65.9891 17.0793 68.9484C21.4531 71.9077 26.3996 73.9155 31.5986 74.8417C36.7976 75.7679 42.1331 75.5919 47.2598 74.3251C52.3864 73.0584 57.1899 70.729 61.3592 67.488C65.5285 64.2469 68.9706 60.1664 71.4627 55.5105C73.8064 51.132 75.2607 46.3364 75.7456 41.4C75.7965 40.8818 75.4051 40.4298 74.8857 40.3919C74.3664 40.354 73.9159 40.7444 73.8644 41.2625C73.3991 45.9356 72.0193 50.4749 69.8002 54.6207C67.4327 59.0437 64.1627 62.9202 60.2019 65.9992C56.2411 69.0782 51.6778 71.2911 46.8074 72.4945C41.9371 73.698 36.8683 73.8651 31.9293 72.9852C26.9903 72.1053 22.2911 70.198 18.136 67.3866C13.9809 64.5753 10.4626 60.9227 7.80877 56.6652C5.15497 52.4078 3.42487 47.6405 2.7305 42.672C2.07965 38.0149 2.35234 33.2784 3.52955 28.7322C3.66008 28.2281 3.37216 27.7061 2.87169 27.5624Z",
      "fill": "#F22A42"
    }
  }), _c('path', {
    attrs: {
      "d": "M68.7601 17.2451C69.1926 16.9552 69.7794 17.0704 70.0583 17.5101C73.6139 23.1144 75.6275 29.5584 75.8955 36.19C75.9165 36.7103 75.4997 37.1391 74.9791 37.1471C74.4584 37.1551 74.0312 36.7393 74.0095 36.2191C73.7479 29.9513 71.845 23.8616 68.4913 18.5601C68.2129 18.12 68.3275 17.5349 68.7601 17.2451Z",
      "fill": "#F22A42"
    }
  })]);

}
var staticRenderFns = []

export { render, staticRenderFns }